<template>
  <v-dialog v-model="dialog" max-width="800" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-items-center justify-content-center">
        <v-btn
          color="#3F4443"
          rounded
          outlined
          small
          class="ml-5 text-uppercase"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon dark> mdi-magnify-plus </v-icon>
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>Contents</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form v-if="config">
          <div class="form-row d-flex align-items-end">
            <v-row
              v-for="(data, index) in config"
              :key="index"
              style="padding-right: 15px;padding-left: 15px;"
            >
              <v-col
                md="6"
                v-for="(value, key, fieldIndex) in data"
                :key="fieldIndex"
              >
                <v-text-field
                  disabled
                  required
                  :name="key"
                  :label="key"
                  outlined
                  v-model="data[key]"
                >
                  {{ value }}
                </v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions
          class="d-flex align-items-center justify-content-center"
        >
          <v-btn color="#717C7D" text @click="dialog = false">{{
            $t("lang.location_form.btn_close")
          }}</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
      config: [],
      dialog: false,
      errorLabels: {
        field: this.$t("All field are require")
      }
    };
  },
  mounted() {
    try {
      // TODO this is an array, but I was not able to make the for. You have to correct it
      this.config = this.data;
    } catch (error) {
      this.errors.push(this.errorLabels.notFound);
    }
  },
  methods: {
    async submitForm() {
      let input = Object.assign({}, this.config);
      console.log("input", this.config);
    },
    validate() {
      this.errors = [];
      let keys = Object.keys(this.config);
      for (let i = 0; i < keys.length; i++) {
        // eslint-disable-next-line no-undef
        let val = obj[keys[i]];
        if (!val) {
          this.errors.push(this.errorLabels.field);
          return false;
        }
      }
      return true;
    }
  }
};
</script>
<style></style>
